/*
 * サブシステム名：設定その他
 * 機能名：データ取込
 */

import DdDropDown from '@/components/DdDropDown'
import DdSubHeader from '@/components/DdSubHeader'
import DdDefaultButton from '@/components/DdDefaultButton'
import DdNarrowDownTextBox from '@/components/DdNarrowDownTextBox'
import DdRowCountBox from '@/components/DdRowCountBox'
import DdFileInput from '@/components/DdFileInput'
import DdFooterButton from '@/components/DdFooterButton'
import DdDataTable from '@/components/DdDataTable'
import flowMixin from '@/mixins/flowMixins'
import { mapGetters } from 'vuex'
import dayjs from 'dayjs'

export default {
  name: 'DataImportList',
  mixins: [flowMixin],
  data: () => ({
    expansionPanel: [0, 1],
    conditions: {
      maker: '',
      file: ''
    },
    modeKengen: 0
  }),
  components: {
    DdSubHeader,
    DdDropDown,
    DdDefaultButton,
    DdNarrowDownTextBox,
    DdRowCountBox,
    DdFileInput,
    DdFooterButton,
    DdDataTable
  },
  computed: {
    ...mapGetters({
      makerList: 'DDMasters/mstDigitakoJoho'
    }),
    filteredMaker () {
      // /* eslint no-debugger: "warn" */
      // debugger
      return this.makerList.filter(function (elem) {
        return elem
      }).map(function (elem) {
        elem.value = elem.digitakoTeigiId
        elem.text = elem.digitakoName
        return elem
      }).sort((elem1, elem2) => {
        if (elem1.digitakoTeigiId > elem2.digitakoTeigiId) { return 1 }
        if (elem1.digitakoTeigiId === elem2.digitakoTeigiId) { return 0 }
        return -1
      })
    },
    isValidImportButton () {
      if (this.modeKengen === 0) {
        return false
      }
      return true
    },
    filteredRows () {
      return this.rows.map((elem) => {
        elem.importStartDisp = elem.importStart ? dayjs(elem.importStart).format('YYYY/MM/DD HH:mm:ss') : ''
        elem.importEndDisp = elem.importEnd ? dayjs(elem.importEnd).format('YYYY/MM/DD HH:mm:ss') : ''
        return elem
      })
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['mstdigitakojoho'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            self.headers = [
              { text: 'No', value: 'csvRowNo', align: 'center' },
              { text: '運行ID', value: 'UnkoJissekiNo', align: 'center' },
              { text: '乗務員', value: 'jomuin' },
              { text: '同乗者', value: 'dojosha' },
              { text: '車輛', value: 'sharyoNo' },
              { text: '車種', value: 'sharyoSbt' },
              { text: '運行年月日', value: 'exportResult' },
              { text: 'デジタコ運行ID', value: 'digitakoUnkoId' },
              { text: 'デジタコ運行ID枝番', value: 'digitakoUnkoIdEdaNo' },
              { text: '運行開始年月日', value: 'unkoStartYmd' },
              { text: '運行開始時刻', value: 'unkoStartHms' },
              { text: '運行終了年月日', value: 'unkoEndYmd' },
              { text: '運行終了時刻', value: 'unkoEndHms' },
              { text: 'エラー情報', value: 'errorMsg' }
            ]
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.conditions = {
              maker: '',
              file: '',
              filePath: '',
              fileName: ''
            }
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          // ユーザ保存項目の復元
          self.conditions = { ...self.conditions, ...c }
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            self.searchText = c.cache.value.searchText || ''
            self.rows = c.cache.value.rows || []
          })
        },
        settingButtonStatePromise: (kengen) => {
          return new Promise(resolve => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }
            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    clear: function () {
      console.log('clear pushed')
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            this.conditions = {
              maker: '',
              file: '',
              filePath: '',
              fileName: ''
            }
            this.searchText = ''
            this.rows = []
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onTorikomiButtonClick: function (e) {
      console.log('cklick')
      if (this.validateAll(this.$refs)) {
        this.Effects.loadStart()
        console.log('Torikomi start', e)
        this.HttpClient.post('/api/v1/D2PRMD0800/Exec', this.conditions)
          .then((data) => {
            if (data.isValid) {
              console.log('retdata', data)
              this.transition(0, { id: data.payload, edit: 1 })
            } else {
              this.setSummaryMessage(data.summaryMessage)
              this.Effects.loadComplete()
            }
          }).catch((e) => {
            console.log('error', e)
            this.setSummaryMessage(e.message)
            this.Effects.loadComplete()
          })
      }
    },
    onClearButtonClick: function (e) {
      console.log('clear pushed')
      this.Effects.loadStart()
      this.clear()
    },
    onRowClick: function (e) {
      console.log(e)
      this.Effects.loadStart()

      this.transition(0, { id: e.id, edit: 0 })
    },
    searchValidate: function () {
      return true
    },
    storeFileInfo: function (file) {
      console.log('file selected', file)

      if (file === undefined || file === null) {
        this.conditions.fileData = ''
        this.conditions.fileName = ''
        return
      }
      this.conditions.fileName = file.name

      const fr = new FileReader()
      fr.readAsDataURL(file)
      fr.addEventListener('load', () => {
        this.conditions.fileData = fr.result
      })
      console.log('file selected e')
    }
  }
}
